<template>
  <div id="map-wrapper" class="map-wrapper">
    <div v-if="province" class="province-title text-left">
      <h3 class="text-center">
        {{province.SGG_2}}
        <br />
        <h4>
          <template v-if="province.seatInfo && province.seatInfo.elected">
            <vote21-award :width="30" :height="30"></vote21-award>
            <strong class="text-warning">
            {{ province.seatInfo.elected.partyName }}, {{ province.seatInfo.elected.name }}
            </strong>
          </template>
          <template v-else-if="province.seatInfo && province.seatInfo.first">
            {{ province.seatInfo.first.partyName }}, {{ province.seatInfo.first.name }}
          </template>
          <template v-else-if="province.seatInfo && province.seatInfo.final && province.seatInfo.final.first">
            {{ province.seatInfo.final.first.partyName }}, {{ province.seatInfo.final.first.name }}
          </template>
          <template v-else-if="province.seatInfo && province.seatInfo.exitpoll && province.seatInfo.exitpoll.first">
            {{ province.seatInfo.exitpoll.first.partyName }}, {{ province.seatInfo.exitpoll.first.name }}
          </template>
          <template v-else-if="province.seatInfo && province.seatInfo.poll && province.seatInfo.poll.first">
            {{ province.seatInfo.poll.first.partyName }}, {{ province.seatInfo.poll.first.name }}
          </template>
        </h4>
      </h3>
      <div v-if="!currentProvince">
        <span v-html="province.metadata[1]"></span>
      </div>
    </div>

    <div v-if="currentProvince" class="province-info">
      <h3 class="text-center">
        {{currentProvince.SGG_2}}
        <br />
        <h4>
          <template v-if="currentProvince.seatInfo && currentProvince.seatInfo.elected">
            <vote21-award :width="30" :height="30"></vote21-award>
            <strong class="text-warning">
            {{ currentProvince.seatInfo.elected.partyName }}, {{ currentProvince.seatInfo.elected.name }}
            </strong>
          </template>
          <template v-else-if="currentProvince.seatInfo && currentProvince.seatInfo.first">
            {{ currentProvince.seatInfo.first.partyName }}, {{ currentProvince.seatInfo.first.name }}
          </template>
          <template v-else-if="currentProvince.seatInfo && currentProvince.seatInfo.final && currentProvince.seatInfo.final.first">
            {{ currentProvince.seatInfo.final.first.partyName }}, {{ currentProvince.seatInfo.final.first.name }}
          </template>
          <template v-else-if="currentProvince.seatInfo && currentProvince.seatInfo.exitpoll && currentProvince.seatInfo.exitpoll.first">
            {{ currentProvince.seatInfo.exitpoll.first.partyName }}, {{ currentProvince.seatInfo.exitpoll.first.name }}
          </template>
          <template v-else-if="currentProvince.seatInfo && currentProvince.seatInfo.poll && currentProvince.seatInfo.poll.first">
            {{ currentProvince.seatInfo.poll.first.partyName }}, {{ currentProvince.seatInfo.poll.first.name }}
          </template>
        </h4>
      </h3>

      <ul class="text-left">
        <!-- <li>
          <span v-html="currentProvince.metadata[1]"></span>
        </li> -->
        <!--
        <li>정당: {{findPartyName(currentProvince.SGG_Code)}}</li>
        <li>SGG_Code: {{currentProvince.SGG_Code}}</li>
        <li>SGG_1: {{currentProvince.SGG_1}}</li>
        <li>SGG_2: {{currentProvince.SGG_2}}</li>
        <li>SGG_2: {{currentProvince.SGG_3}}</li>
        -->

        <template v-if="currentProvince.seatInfo && currentProvince.seatInfo.candidate">
        <li> 후보자 :
          <ul>
            <template v-for="candidate in currentProvince.seatInfo.candidate">
              <li :key="candidate.no">기호 {{ candidate.no }} 번, {{ candidate.partyName }}, {{ candidate.name }}</li>
            </template>
          </ul>
        </li>
        </template>

        <template v-if="currentProvince.seatInfo && currentProvince.seatInfo.final">
        <li> 
          <b-row>
            <b-col class="col-12 col-md-6 text-white">
              개표결과
            </b-col>
            <b-col class="col-12 col-md-6 text-white text-right">
              <vote21-fire
                :delta="currentProvince.seatInfo.final.encounter"
              ></vote21-fire>
            </b-col>
            <b-col class="col-12 text-white">
              <vote21-ratio-bar
                :party-list="partyList"
                :data="currentProvince.seatInfo.final.data"
              ></vote21-ratio-bar>
            </b-col>
          </b-row>
        </li>
        </template>

        <template v-if="currentProvince.seatInfo && currentProvince.seatInfo.exitpoll">
        <li> 
          <b-row>
            <b-col class="col-12 col-md-6 text-white">
              출구조사
            </b-col>
            <b-col class="col-12 col-md-6 text-white text-right">
              <vote21-fire
                :delta="currentProvince.seatInfo.exitpoll.encounter"
              ></vote21-fire>
            </b-col>
            <b-col class="col-12 text-white">
              <vote21-ratio-bar
                :party-list="partyList"
                :data="currentProvince.seatInfo.exitpoll.data"
              ></vote21-ratio-bar>
            </b-col>
          </b-row>

          <template v-if="currentProvince.seatInfo && !currentProvince.seatInfo.final">
          <b-row>
            <template v-for="(poll, key) in currentProvince.seatInfo.exitpolls">
              <b-col :key="key" class="col-4 pl-3">
                <b-row class="mt-1">
                  <b-col class="col-12 text-white">
                    출구조사 {{ key }}
                  </b-col>
                  <b-col class="col-12 text-right">
                    <vote21-ratio-bar
                      :party-list="partyList"
                      :data="poll"
                    ></vote21-ratio-bar>
                  </b-col>
                </b-row>
              </b-col>
            </template>
          </b-row>
        </template>

        </li>
        </template>

        <li v-if="currentProvince.seatInfo && currentProvince.seatInfo.polls && currentProvince.seatInfo.polls.length > 0">
          
          <template v-if="currentProvince.seatInfo && currentProvince.seatInfo.poll">
            <b-row>
              <b-col class="col-12 col-md-6 text-white">
                여론조사
              </b-col>
              <b-col class="col-12 col-md-6 text-white text-right">
                <vote21-fire
                  :delta.sync="currentProvince.seatInfo.poll.encounter"
                ></vote21-fire>
              </b-col>
              <b-col class="col-12 text-white">
                <vote21-ratio-bar
                  :party-list="partyList"
                  :data="currentProvince.seatInfo.poll.data"
                ></vote21-ratio-bar>
              </b-col>
            </b-row>
          </template>
          <template v-if="currentProvince.seatInfo && currentProvince.seatInfo.polls && !currentProvince.seatInfo.exitpoll">
            <b-row>
              <template v-for="(poll, index) in currentProvince.seatInfo.polls">
                <b-col :key="index" class="col-12 col-lg-6">
                  <b-row class="my-1">
                    <b-col class="col-12 text-white">
                      <template v-if="poll.requester && poll.research">
                        {{ poll.requester }}, {{ poll.research }}<br />
                      </template>
                      <template v-else>
                        {{ poll.requester }} {{ poll.research }}<br />
                      </template>
                      <small>
                        응답자 : {{ poll.period }}
                        <!-- , {{ poll.respondent | digit }}명 -->
                        , <a href="#" @click.stop.prevent="goLink(poll.link)">출처</a>
                      </small>
                    </b-col>
                    <b-col class="col-12">
                      <vote21-ratio-bar
                        :party-list="partyList"
                        :data="poll.data"
                      ></vote21-ratio-bar>
                    </b-col>
                    <b-col class="col-12 d-none d-lg-block">
                      <small>
                        {{ poll.desc }}
                      </small>
                    </b-col>
                  </b-row>
                </b-col>
              </template>
            </b-row>
          </template>
        </li>
      </ul>
    </div>

    <div class="province-state text-left" v-if="!currentProvince">
      <h4 class="text-center">개표 현황</h4>
      <ul>
        <li>당선 확정 : {{localSeatState.elected | digit }}석</li>
        <li>초경합({{ RATIO_VERY_ENCOUNTER }}%) : {{localSeatState.veryencounter | digit }}석</li>
        <li>경합({{ RATIO_ENCOUNTER }}%) : {{localSeatState.encounter | digit }}석</li>
        <li>개표 중 : {{localSeatState.counting | digit }}석</li>
        <li>개표/조사 전 : {{localSeatState.unknown | digit }}석</li>
      </ul>
    </div>

    <div class="province-summary text-left" v-if="!currentProvince">
      <h4 class="text-center">정당별 현황</h4>
      <ul>
        <template v-for="(value, key) in localSeatData">
          <li :key="key" v-if="key === 'undecided'">개표/조사 안됨 : {{value | digit }}석</li>
          <li :key="key" v-else>{{ partyList[key].name }} : {{value | digit }}석</li>
        </template>
      </ul>
    </div>
  </div>
</template>



<script>

const vote21_define = require('./Vote21.Define').default;


// const polls = require('./polls.json');
// console.log("polls : " + JSON.stringify(polls));

// https://ko.wikipedia.org/wiki/%EB%8C%80%ED%95%9C%EB%AF%BC%EA%B5%AD_%EC%A0%9C21%EB%8C%80_%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90_%EC%84%A0%EA%B1%B0_%EC%97%AC%EB%A1%A0_%EC%A1%B0%EC%82%AC#5%EC%B0%A8_%EC%A0%95%EA%B3%84_%EA%B0%9C%ED%8E%B8_%EC%9D%B4%ED%9B%84_2
// const proportionalSeatPolls = require('./proportional.poll.json');
// const localSeatPolls = require('./localseat.poll').default;
// const localSeatCodes = require('./localseat.code.json');
// const localSeatCandidate = require('./localseat.candidate').default;


// http://www.ohmynews.com/NWS_Web/View/at_pg_w.aspx?CNTN_CD=A0002623791
// https://github.com/OhmyNews/2020_21_elec_map/blob/master/2020_21_elec_253_simple.json
// https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC
// https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%ED%9B%84%EB%B3%B4%EC%9E%90
import * as d3 from 'd3'
import localseatPoll from './localseat.poll'

const Vote21Fire = require('./Vote21.Fire').default;
const Vote21RatioBar = require('./Vote21.RatioBar').default;
const Vote21Award = require('./Vote21.Award').default;

export default {
  components: {
    "vote21-fire" : Vote21Fire,
    "vote21-ratio-bar" : Vote21RatioBar,
    "vote21-award" : Vote21Award
  },
  props: {
    'partyList': {
      type: Object
    },
    'mapData': {
      type: Object
    },
    'localSeatData': {
      type: Object
    },
    'localSeatState': {
      type: Object
    }
  },
  data() {
    return {
      province: undefined,
      currentProvince: undefined,
      localSeatInfo : this.mapData,
      
      RATIO_VERY_ENCOUNTER : vote21_define.RATIO_VERY_ENCOUNTER,
      RATIO_ENCOUNTER : vote21_define.RATIO_ENCOUNTER
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.drawMap();
  },

  methods: {
    selectProvince(province) {
      if(province) {
        // console.log(province);
        province.seatInfo = this.localSeatInfo[province.SGG_Code];
      }
      this.province = province;
    },

    openInfo(province) {
      // console.log(province);
      if(province) {
        province.seatInfo = this.localSeatInfo[province.SGG_Code];
      }
      this.currentProvince = province;
    },

    closeInfo() {
      this.currentProvince = undefined;
    },

    // findParty(code) {
    //   const localSeat = this.localSeatInfo[code];
    //   if(localSeat) {
    //     // console.log("findParty", localSeat)
    //     let candidate = null;
    //     candidate = localSeat && localSeat.poll ? localSeat.poll.first : candidate;
    //     candidate = localSeat && localSeat.exitpoll ? localSeat.exitpoll.first : candidate;
    //     candidate = localSeat && localSeat.final ? localSeat.final.first : candidate;
    //     return candidate ? this.partyList[candidate.party] : null;
    //   }
    //   return null;
    // },

    findPartyColor(code) {
      let color = null;
      const localSeat = this.localSeatInfo[code];
      if(localSeat) {
        // console.log("findParty", localSeat)
        let candidate = null;
        candidate = localSeat.poll ? localSeat.poll.first : candidate;
        candidate = localSeat.exitpoll ? localSeat.exitpoll.first : candidate;
        candidate = localSeat.final ? localSeat.final.first : candidate;
        candidate = localSeat.elected ? localSeat.elected : candidate;

        color = candidate ? candidate.color : null;

        let encounter = 0;
        if(localSeat.elected) {
          // color = elected.color;
        }
        else if(localSeat.final && localSeat.final.encounter) {
          encounter = localSeat.final.encounter;
        }
        else if(localSeat.exitpoll && localSeat.exitpoll.encounter) {
          encounter = localSeat.exitpoll.encounter;
        }
        else if(localSeat.poll && localSeat.poll.encounter) {
          encounter = localSeat.poll.encounter;
        }
        if(encounter > 0) {
          // color = encounter <= __RATIO_VERY_ENCOUNTER ? "#ff0000" : (encounter <= __RATIO_ENCOUNTER ? "#ff3333" : color);
        }
      }


      return color;
    },



    // https://codepen.io/lantoine/pen/ExxEGxg
    // https://m.blog.naver.com/PostView.nhn?blogId=jhc9639&logNo=221195987416&proxyReferer=https%3A%2F%2Fwww.google.com%2F
    drawMap() {
      const localseats = require('./localseat.map.json');
      // const koreaMap = require('../map/skorea_municipalities_topo_simple.json');
      // const geojson = localseats.feature(localseats);
      const geojson = localseats;
      const center = d3.geoCentroid(geojson);

      let centered = undefined;

      const divWidth = document.getElementById("map-wrapper").clientWidth;
      const width = (divWidth < 1000) ? divWidth * 0.9 : 1000;
      const height = width * 1;
      const svg = d3
      // .select('.d3')
        .select('.map-wrapper')
        .append('svg')
        .attr('width', width)
        .attr('height', height);
      // const map = svg.append('g');

      const background = svg.append('rect')
        .attr('class', 'background')
        .attr('width', width)
        .attr('height', height)

      const g = svg.append('g');
      // const effectLayer = g.append('g').classed('effect-layer', true);
      const mapLayer = g.append('g').classed('map-layer', true);

      let projection = d3.geoMercator()
        .scale(1)
        .translate([0, 0]); 

      const path = d3.geoPath().projection(projection);
      const bounds = path.bounds(geojson);
      const widthScale = (bounds[1][0] - bounds[0][0]) / width; 
      const heightScale = (bounds[1][1] - bounds[0][1]) / height; 
      const scale = 0.95 / Math.max(widthScale, heightScale);
      const xoffset = width/2 - scale * (bounds[1][0] + bounds[0][0]) /2 + 0; 
      const yoffset = height/2 - scale * (bounds[1][1] + bounds[0][1])/2 + 0; 
      const offset = [xoffset, yoffset];
      projection.scale(scale).translate(offset);

      const _this = this;
      function clicked(d) {
        var x, y, k;

        // Compute centroid of the selected path
        if (d && centered !== d) {
          var centroid = path.centroid(d);
          x = centroid[0];
          y = centroid[1];
          k = 4;
          centered = d;
          _this.openInfo(d.properties);
        } else {
          x = width / 2;
          y = height / 2;
          k = 1;
          centered = null;
          _this.closeInfo();
        }

        // Highlight the clicked province
        mapLayer.selectAll('path')
          .style('fill', function(d){
            return centered && d===centered ? '#D5708B' : fillFn(d);
        });

        // Zoom
        g.transition()
          .duration(750)
          .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')scale(' + k + ')translate(' + -x + ',' + -y + ')');
        
      }

      const color = d3.scaleLinear()
        .domain([1, 20])
        .clamp(true)
        // .range(['#08304b', '#08304b']);
        .range(['#595959', '#595959']);

      function mouseover(d){
        // Highlight hovered province
        d3.select(this).style('fill', '#1483ce');
        // d3.select(this).style('fill', '#004EA2');
        if(d) {
          _this.selectProvince(d.properties);
        }
      }

      function mouseout(d){
        _this.selectProvince(undefined);
        // Reset province color
        mapLayer.selectAll('path')
          .style('fill', (d) => {
            return centered && d===centered ? '#D5708B' : fillFn(d);
          });
      }

      // Get province name length
      function nameLength(d){
        const n = nameFn(d);
        return n ? n.length : 0;
      }

      // Get province name
      function nameFn(d){
        return d && d.properties ? d.properties.name : null;
      }

      function partyColor(d) {
        return _this.findPartyColor(d.properties.SGG_Code);
        // const party = _this.findParty(d.properties.SGG_Code);
        // return (party)? party.color : null;
        // return color;
      }

      // Get province color
      function fillFn(d){
        // console.log(d, nameLength(d));
        // console.log(d.properties);

        const pcolor = partyColor(d);
        if(pcolor) {
          // console.log(pcolor);
          // d3.select(d).style('fill', pcolor);
          return pcolor;
        }

        return color(nameLength(d));
      }

      // Add background
      background
        .on('click', clicked);

      mapLayer
        .selectAll('path')
        .data(geojson.features)
        .enter().append('path') 
        .attr('d', path)
        .attr('vector-effect', 'non-scaling-stroke')
        .style('fill', fillFn)
        .on('mouseover', mouseover)
        .on('mouseout', mouseout)
        .on('click', clicked);

      const zoomed = () =>{
        mapLayer.attr('transform', d3.event.transform)
        // icons.attr('transform', d3.event.transform)
      }
      const zoom = d3.zoom().scaleExtent([1, 8]).on('zoom', zoomed)
      svg.call(zoom)
    }
  }
}

/*
const wrapper = d3.select('.map-wrapper');
console.log("wrapper", wrapper, wrapper.node());

// Set svg width & height
let centered = undefined;
const mapCenter = {
  lat: 1.4,
  lng: 117.5
};
const size = {
  height: 700,
  // width: wrapper.node().getBoundingClientRect().width,  
  width: 1000,
};

// const color = d3.scale.linear()
const color = d3.scaleLinear()
  .domain([1, 20])
  .clamp(true)
  .range(['#08304b', '#08304b']);

// const projection = d3.geo.equirectangular()
const projection = d3.geoEquirectangular()
  .scale(1400)
  .center([mapCenter.lng, mapCenter.lat])
  .translate([size.width / 2, size.height / 2]);

// const path = d3.geo.path()
const path = d3.geoPath()
  .projection(projection);

const svg = d3.select('svg')
  .attr('width', size.width)
  .attr('height', size.height);

// Add background
svg.append('rect')
  .attr('class', 'background')
  .attr('width', size.width)
  .attr('height', size.height)
  .on('click', clicked);

const g = svg.append('g');

const effectLayer = g.append('g')
  .classed('effect-layer', true);
const mapLayer = g.append('g')
  .classed('map-layer', true);
 
// Load map data
const geoJsonUrl = './vote21.localseat.map.json';
// d3.json(geoJsonUrl, function(error, mapData) {
//   var features = mapData.features;
  var features = localseats.features;
  console.log(features);

  // Update color scale domain based on data
  color.domain([0, d3.max(features, nameLength)]);

  // Draw each province as a path
  mapLayer.selectAll('path')
      .data(features)
    .enter().append('path') 
      .attr('d', path)
      .attr('vector-effect', 'non-scaling-stroke')
      .style('fill', fillFn)
      .on('mouseover', mouseover)
      .on('mouseout', mouseout)
      .on('click', clicked);
// });

function clicked(d) {
  var x, y, k;

  // Compute centroid of the selected path
  if (d && centered !== d) {
    var centroid = path.centroid(d);
    x = centroid[0];
    y = centroid[1];
    k = 4;
    centered = d;
    app.openInfo(d.properties);
  } else {
    x = size.width / 2;
    y = size.height / 2;
    k = 1;
    centered = null;
    app.closeInfo();
  }

  // Highlight the clicked province
  mapLayer.selectAll('path')
    .style('fill', function(d){
      return centered && d===centered ? '#D5708B' : fillFn(d);
  });

  // Zoom
  g.transition()
    .duration(750)
    .attr('transform', 'translate(' + size.width / 2 + ',' + size.height / 2 + ')scale(' + k + ')translate(' + -x + ',' + -y + ')');
}

function mouseover(d){
  // Highlight hovered province
  d3.select(this).style('fill', '#1483ce');
  if(d) {
    app.selectProvince(d.properties);
  }
}

function mouseout(d){
  app.selectProvince(undefined);
  // Reset province color
  mapLayer.selectAll('path')
    .style('fill', (d) => {
      return centered && d===centered ? '#D5708B' : fillFn(d);
    });
}

// Get province name length
function nameLength(d){
  const n = nameFn(d);
  return n ? n.length : 0;
}

// Get province name
function nameFn(d){
  return d && d.properties ? d.properties.name : null;
}

// Get province color
function fillFn(d){
  return color(nameLength(d));
}
*/
</script>

<style lang="scss">
.map-wrapper {
  position:relative;
  text-align: center;

  // svg {
  //   border: 1px solid #aaaaaa;
  // }

  .province-title {
    position: absolute;
    top: 10px;
    left: 40px;
    width: 600px;
    color: white;
    z-index: 100;
    pointer-events: none;
    font-size: 0.9rem;
  }
  .province-info {
    // background: white;
    position: absolute;
    color: white;
    top: 50px;
    right: 60px;
    width: 600px;
    height: 500px;
    z-index: 101;
    font-size: 0.9rem;
    pointer-events: none;
  }
  .province-state {
    // background: white;
    position: absolute;
    color: white;
    bottom: 200px;
    right: 10px;
    width: 300px;
    z-index: 102;
    pointer-events: none;
  }
  .province-summary {
    // background: white;
    position: absolute;
    color: white;
    bottom: 10px;
    right: 10px;
    width: 300px;
    z-index: 103;
    pointer-events: none;
  }
  .province-state > ul, .province-summary > ul {
    list-style: none;
  }
  .background {
    /* fill: #021019; */
    fill: transparent;
    pointer-events: all;
  }
  .map-layer {
    fill: #08304b;
    stroke: #021019;
    stroke-width: 1px;
  }
}
</style>
